<template>
  <div class="mc-auth-login">
    <div style="padding: 67px 0; display: flex; justify-content: center">
      <img :src="logo" style="width: 99px; height: 99px;" alt="">
    </div>
    <div style="text-align: center; font-size: 18px; color: #191919">绑定手机号</div>
    <van-form style="margin-top: 36px" @submit="onSubmit">
      <van-field
        v-model="mobile"
        name="手机号"
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ required: true, message: '手机号不能为空' }]"
        class="my-field"
      >
        <template #button>
          <van-button style="margin-right: 8px" size="small" @click="showPopup">{{ region }}</van-button>
        </template>
      </van-field>
      <van-popup v-model="popupVisible" position="bottom" round :style="{ height: '30%' }">
        <van-cell-group>
          <van-cell v-for="item in countryCodes" :key="item.code" :title="item.name" @click="selectCountryCode(item.code)" />
        </van-cell-group>
      </van-popup>
      <van-field
        v-model="code"
        name="验证码"
        label="验证码"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '验证码不能为' }]">
        <template #button>
          <van-button size="small" type="info" @click.stop.prevent="getCode" :disabled="disabled" style="border-radius: 4px">{{ valiBtn }}</van-button>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">立刻关联</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue'
import {Field, Form, Toast, Image as VanImage, Icon, CellGroup, Popup, Cell } from 'vant'
import { S365Util } from '@/utils/s365Util'
import {QNImageUtil} from "@/utils";
import { sendSmsValidationCode, updateBanmaUserMobile } from "@/api/match";
Vue.use(Field).use(Form).use(VanImage).use(Icon).use(CellGroup).use(Popup).use(Cell)

export default {
  data() {
    return {
      region: '+86',
      logo: '',
      redirect: '',
      mobile: '',
      code: '',
      valiBtn: '获取验证码',
      disabled: false,
      popupVisible: false,
      countryCodes: [
        { name: '中国大陆 (+86)', code: '+86' },
        { name: '中国台湾 (+886)', code: '+886' },
      ]
    }
  },
  mounted() {
    this.redirect = this.$route.query.redirect
    if (S365Util.isInApp()) {
      this.logo = QNImageUtil.originView('FhVneyw0pMrHZgYR4oT1cPo7_8es')
    } else {
      this.logo = QNImageUtil.originView('FmrRsONDG8NJKfhs7dQ-Z348JMm0')
    }
  },
  methods: {
    onSubmit() {
      const params = {}
      if (this.region === '+886') {
        params.mobile = '886-' + this.mobile
      } else {
        params.mobile = this.mobile
      }
      params.code = this.code
      updateBanmaUserMobile(params).then(res => {
        if (res) {
          Toast('绑定成功')
          this.$router.go(-1)
        }
      })
    },
    getCode() {
      if (this.disabled) {
        return
      }
      let params = {}
      if (!this.mobile) {
        Toast('请先输入手机号')
        return
      }
      params = {
        loginType: 'mobile',
        action: 'sendFastBindCode'
      }
      if (this.region === '+886') {
        params.mobile = '886-' + this.mobile
      } else {
        params.mobile = this.mobile
      }
      this.tackBtn()
      sendSmsValidationCode(params).then(res => {
        if (res) {
          const { data } = res
          if (!data.send) {
            Toast('请稍后重试')
          }
        }
      })
    },
    tackBtn() {
      let time = 60
      this.valiBtn = '60秒后重试'
      this.disabled = true
      const timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer)
          this.valiBtn = '获取验证码'
          this.disabled = false
        } else {
          this.disabled = true
          this.valiBtn = time + '秒后重试'
          time--
        }
      }, 1000)
    },
    showPopup() {
      this.popupVisible = true;
    },
    selectCountryCode(code) {
      this.region = code // 在选择国家代码后自动在输入框中添加空格
      this.popupVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.mc-auth-login {
  .my-field {
    ::v-deep .van-field__body {
      display: flex;
      flex-flow: row-reverse;
    }
  }
}
</style>
